import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Fragment } from 'react/jsx-runtime';
import { Link } from '~/components/Link/Link';

export function Page() {
  return (
    <Fragment>
      <PageLayout.Heading text="Konto skapat!" />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--size-4)' }}>
        <p>
          Tack för att du registrerat dig. Vi har skickat ett verifieringsmail till e-postadressen du angav. Följ länken
          i mailet för att bekräfta din e-postadress och aktivera ditt konto.
        </p>
        <p>
          Om du inte hittar mailet, kontrollera din skräppostmapp. Du kan även använda funktionen{' '}
          <Link to="/auth/reset-password/request" underline>
            Återställ lösenord
          </Link>{' '}
          för att få ett nytt verifieringsmail.
        </p>
      </div>
    </Fragment>
  );
}
